import React, { useState, useEffect, useContext } from 'react';
import { Header, Footer } from './';
import { Pagination, NavigationBar } from '../components';
import { useNavigate, Link } from 'react-router-dom';
import { DashboardMenu } from '../components';
import { SiteContext } from '../context';
import ReactModal from 'react-modal';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    name: Yup.string()
      .label('Name')
      .required()
      .min(3, 'Must have at least 3 characters')
      });


const Brands = () => {

  let navigate = useNavigate();

  const { apiUrl, isMobile } = useContext(SiteContext);

  const userData = JSON.parse(localStorage.getItem('user'));

  const [brands, setBrands] = useState([]);
  const [mode, setMode] = useState('');
  const [uploadedPic, setUploadedPic] =  useState(null);
  const [total, setTotal] = useState(null);
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(1);
  const [cangoBack, setCangoBack] = useState(true);
  const [cangoForward, setCangoForward] = useState(true);
  const [updateItem, setUpdateItem] = useState({});
  const [itemSelected, setItemSelected] = useState('');
  const [msg, setMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModalBrand, setShowModalBrand] = useState(false);

  useEffect(() => {
    getBrands();
  }, [page, limit])

  const getBrands = () => {
    fetch(`${apiUrl}/api/brands.php?action=fetch&role=${userData.role}&page=${page}&limit=${limit}`, {
      method: 'get'
    }).then((res) => {
      return res.json()
    }).then((res) => {

      if (res.status === 200) {
        if (res.rows.length > 0) {
          setBrands(res.rows);
          setTotal(res.rows.length);
        }
      } else if (res.status === 400) {
        setErrorMsg(res.msg)
        setTimeout(() => {
          setErrorMsg('')
        }, 5000)
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  const handleSubmit = (values, { setSubmitting, resetForm, setShowModalBrand }) => {

    let formData = new FormData();
  
    formData.append('name', values.name);
    formData.append('picture', values.picture);
    formData.append('bid', values.id);
    formData.append('action', mode);
  
    const url = `${apiUrl}/api/brands.php`;
    const sendType = 'post';
  
      return fetch(url, {
        method: sendType,
        body: formData
      })
        .then((res) => res.json())
        .then((res) => {

          if(res.status === 200) {
            setMsg(res.msg);
            resetForm({});
            setSubmitting(false);      
            getBrands();
            setTimeout(() => {
                setMsg('');
              }, 3000);
            setTimeout(() => {
                setShowModalBrand(false);
            }, 4000);
          } else if(res.status === 400) {
            setSubmitting(false);
            setErrorMsg(res.msg);
            setTimeout(() => {
              setErrorMsg('');
            }, 2000);
          } else {
            alert(
                  'Failure',
                  'Error connection to the server please check your details and try again',
                  [{ text: 'Okay' }]
                );
          }
        })
        .catch((error) => {
          console.log('Api call error', error.message);
        });
    };
  

  const doPrevious = async () => {

    if (parseInt(page) > 1) {
      await setPage(() => parseInt(page - 1));
      setCangoBack(true);
      setCangoForward(true);
    } else {
      setCangoBack(false);
      setCangoForward(true);
    }
  }

  const doNext = async () => {

    if (parseInt(page * limit) < total) {
      await setPage(() => parseInt(page + 1));
      setCangoForward(true);
      setCangoBack(true);
    } else {
      setCangoForward(false);
      setCangoBack(true);
    }
  }

  const handleChange = (event) => {
    let newLimit = event.target.value;
    setLimit(newLimit);
  }

  const handleDelete = (id) => {
    setItemSelected(id);
    setShowModal(true);
  }


  const doDelete = (itemSelected) => {
    setShowModal(false);

    let formData = new FormData();

    formData.append('bid', itemSelected);
    formData.append('role', userData.role);
    formData.append('action', 'delete');

    fetch(`${apiUrl}/api/brands.php`, {
      method: 'post',
      body: formData
    }).then((res) => {
      return res.json()
    }).then((res) => {
      if (res.status === 200) {
        setMsg(res.msg);
        getBrands();
        setTimeout(() => {
          setMsg('');
        }, 3000);
          } else if (res.status === 400) {
        setErrorMsg(res.msg)
        setTimeout(() => {
          setErrorMsg('')
        }, 3000);
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  const handleAction = (type,obj) => {

      if(type === 'add') {
        setMode('create');
        setUpdateItem({});
        setUploadedPic(null);
        setShowModalBrand(true);
      } else {
          setMode('update');
          setUpdateItem(obj);
          setShowModalBrand(true);
      }
  }

  return (
    <div>
      <ReactModal
        isOpen={showModal}
        style={{
          overlay: {
            flex: 1,
            justifyContent: 'center',
            alignContent: 'center',
            position: 'fixed',
            top: '10%',
            bottom: '10%',
            left: isMobile ? '10%' : '25%',
            right: isMobile ? '10%' : '25%',
            width: isMobile ? '80%' : '50%',
            height: 250,
            backgroundColor: 'rgba(255, 255, 255, 0.75)'
          },
          content: {
            position: 'absolute',
            top: '20px',
            left: '20px',
            right: '20px',
            bottom: '20px',
            border: '1px solid #ccc',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '20px'
          }
        }}>
        <div>
          <p className='h3 my-1 py-1'>Confirm deletion</p>
          <p className='my-1 py-2'>Action cannot be reversed!</p>
          <span className='btn btn-primary' onClick={() => doDelete(itemSelected)}>Confirm</span> <span className='btn btn-secondary' onClick={() => setShowModal(false)}>Cancel</span>
        </div>
      </ReactModal>

      <ReactModal
              isOpen={showModalBrand}
              style={{
                overlay: {
                  flex: 1,
                  justifyContent: 'center',
                  alignContent: 'center',
                  position: 'fixed',
                  top: '20%',
                  bottom: '10%',
                  left: isMobile ? '10%' : '25%',
                  right: isMobile ? '10%' : '25%',
                  width: isMobile ? '80%' : '50%',
                  height: '70%',
                  backgroundColor: 'rgba(255, 255, 255, 0.75)'
                },
                content: {
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  right: '20px',
                  bottom: '20px',
                  border: '1px solid #ccc',
                  background: '#fff',
                  overflow: 'auto',
                  WebkitOverflowScrolling: 'touch',
                  borderRadius: '4px',
                  outline: 'none',
                  padding: '20px'
                }
              }}>
              <div>
      
      <Formik
                    initialValues={{
                      id: updateItem.id ? updateItem.id : '',
                      name: updateItem.brandname ? updateItem.brandname : '',
                      picture: updateItem.brand_logo ? updateItem.brand_logo : '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      handleSubmit(values, { setSubmitting, resetForm });
                      setTimeout(() => {
                        setShowModalBrand(false);
                      },1000);
                    }}
                  >
                    {({
                      handleChange,
                      values,
                      handleSubmit,
                      errors,
                      isValid,
                      isSubmitting,
                      handleBlur,
                      touched,
                      setFieldValue
                    }) => (
                      <form onSubmit={handleSubmit}  encype="multipart/form-data">
                        <div className='my-2'>
                        
                          <div className='form-group my-2'>
                          <div>
                            <label htmlFor="name">Name</label>
                          </div>
                          <Field
                            id="name"
                            name="name"
                            value={values.name}
                            placeholder="Name"
                            onBlur={handleBlur('name')}
                            autoCapitalize="none"
                            style={{
                              padding: 4
                          }}
                          className="form-control"
                          />
                          {touched.name && errors.name && <div className='py-1'>
                                <span className='text-danger'>{touched.name && errors.name}</span>
                          </div>}
                        </div>

                        <div className='form-group my-2'>
                          <div>
                            <label htmlFor="picture"> Logo</label>
                          </div>
                          <input id="picture" name="picture" type="file" onChange={(event) => {
                                 setFieldValue("picture", event.currentTarget.files[0]);
                                 setUploadedPic(event.currentTarget.files[0]);
                                }} />
                        </div>

                        {uploadedPic && <img className='my-2' src={URL.createObjectURL(uploadedPic)} class="img-fluid mt-2" width={80} height={80} id="output_image"/>}
                        {updateItem.hasOwnProperty('brand_logo') && <img className='my-2' src={`${apiUrl}/${updateItem.brand_logo}`} class="img-fluid mt-2" width={80} height={80} id="logo"/>}

                        </div>
                         
                         
                          <button
                            type='submit'
                            onClick={handleSubmit}
                            title={mode}
                            disabled={!isValid || isSubmitting}
                              className='btn btn-primary my-2'
                          >
                              {mode.charAt(0).toUpperCase()+''+mode.slice(1)}
                          </button>

                          
                    <button
                      onClick={() => setShowModalBrand(false)}
                      title="Cancel"
                      className='btn btn-secondary mx-2'
                    >
                      Cancel
                    </button>
                        
                          </form>
                    )}
                  </Formik>
                  </div>
      </ReactModal>
      <Header />
      <div>
        <div className='row'>
          <div className='col-md-2 bg-light'>
            <DashboardMenu />
          </div>
          <div className='col-md-10'>
            <div className='container my-2'>
            <NavigationBar section={'Products'} goback={true} />

              <h3>Brands | <Link to='/adminproducts'>Products</Link></h3>
              <div className='my-2 d-flex justify-content-between'>
                <div className='align-items-center'>
                  {msg !== '' ? <div className='p-2'><span className='p-2 border border-info text-dark'>{msg}</span></div> : null}
                  {errorMsg !== '' ? <div className='p-2'><span className='p-2 border border-info text-dark'>{errorMsg}</span></div> : null}
                </div>
                <div>
                  <button className='btn btn-primary' onClick={() => handleAction('add',{})}>New</button>
                </div>
              </div>

              {brands.length > 0 && <Pagination limit={limit} page={page} total={total} cangoBack={cangoBack} cangoForward={cangoForward} handleChange={handleChange} doNext={doNext} doPrevious={doPrevious} />}

              {brands.length > 0 &&
                <div className='container p-3'>
                  <div className='row border p-1 bg-light'>
                    <div className='col-1'>No</div>
                    <div className='col-6'>Name</div>
                    <div className='col-3'>Logo</div>
                    <div className='col-2'>Action</div>
                  </div>
                  {brands.map((item, i) => {
                    return (
                      <div key={i} className='row border-bottom py-1'>
                        <div className='col-1'>{++i}</div>
                        <div className='col-6'>{item.brandname}</div>
                        <div className='col-3'><img src={`${apiUrl}/${item.brand_logo}`} height={80} width={100} /></div>
                        <div className='col-2'><a onClick={() => handleAction('update', item)}><i className='bi bi-pencil text-dark h4'></i></a> <a onClick={() => handleDelete(item.id)}><i className='bi bi-trash text-danger h4'></i></a> </div>
                      </div>
                    )
                  })}
                </div>}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Brands;